// extracted by mini-css-extract-plugin
var _1 = "DuHad__brand";
var _2 = "DuHad__copyright";
var _3 = "DuHad__logo";
export { _1 as "brand", _2 as "copyright", _3 as "logo" }
